import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Polizza } from '../models/polizza';
import { Fabbricato } from '../models/fabbricato';
import { baseUrl } from './api-config';
import { ResourcefulService } from './resourcefulService';



@Injectable({
  providedIn: 'root'
})
export class PolizzaService extends ResourcefulService<Polizza>{
  constructor(private httpClient: HttpClient) {
    super(httpClient, Polizza);
  }

  async aggiornaIndirizzoPreesistenza(polizzaId: number): Promise<Fabbricato> {
    const url = `${baseUrl}/polizze/${polizzaId}/aggiorna-indirizzo-preesistenza`;
    const response = await this.httpClient.post<{ data: any }>(url, {}).toPromise();
    return new Fabbricato().deserialize(response?.data);
  }
}
